import { render, staticRenderFns } from "./MicrobialLoadOfFrozenSemenStraw.vue?vue&type=template&id=60b1819c&scoped=true&"
import script from "./MicrobialLoadOfFrozenSemenStraw.vue?vue&type=script&lang=js&"
export * from "./MicrobialLoadOfFrozenSemenStraw.vue?vue&type=script&lang=js&"
import style0 from "./MicrobialLoadOfFrozenSemenStraw.vue?vue&type=style&index=0&id=60b1819c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1819c",
  null
  
)

export default component.exports